/** Route vers l'analyse titre (Stock Dashboard API — TickerAnalysis). */
export function getStockDashboardPath(symbol) {
  const sym = String(symbol || "").trim();
  if (!sym) return null;
  return `/marketflow/ticker/${encodeURIComponent(sym)}`;
}

export function navigateToStockDashboard(navigate, symbol, from) {
  const path = getStockDashboardPath(symbol);
  if (!path || !navigate) return;
  navigate(path, from ? { state: { from } } : undefined);
}

export const TICKER_LINK_STYLE = {
  background: "none",
  border: "none",
  padding: 0,
  margin: 0,
  font: "inherit",
  cursor: "pointer",
  color: "#b59a5b",
  fontFamily: "'IBM Plex Mono',monospace",
  fontWeight: 800,
  textDecoration: "underline",
  textUnderlineOffset: 2,
};

export const TICKER_ASSET_DISPLAY_STYLE = {
  fontWeight: 950,
  color: "#b59a5b",
  textDecoration: "underline",
  textUnderlineOffset: 2,
  fontFamily: "'IBM Plex Mono',monospace",
};
